import { CsiImage, GridRow, OverflowText, Text } from "designSystem/index";
import { C8Node } from "csi/typings";
import React from "react";
import { grey } from "designSystem/styles/color";
import { DataGridCardProps } from "../dataGrid/DataGrid";
import { useLocale } from "designSystem/locale";

const CardItemCard = <T extends C8Node>(props: DataGridCardProps<T>) => {
	const { item } = props;
	const loc = useLocale();
	const itemName = loc.getNodeName(item);

	return (
		<GridRow
			flexWrap="nowrap"
			growChild={1}
			spacing={2}
		>
			<CsiImage
				allowSwitchNodeImages
				aspectRatio={1}
				noImageComponent={(
					<Text
						lineHeight={16}
						res="NoImageAvailable"
						semiBold
						size={14}
						style={{ color: grey[800] }}
					/>
				)}
				node={item}
				width={40}
			/>
			<OverflowText
				lineHeight={16}
				text={itemName}
			/>
		</GridRow>
	);
};

export default CardItemCard;